(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navior-homepage"] && !Shopify.designMode) return;
  try {
    
// generate starfield
const stars = document.getElementById('stars');
for(let i=0;i<80;i++){
  const s = document.createElement('span');
  s.style.left = Math.random()*100+'%';
  s.style.top = Math.random()*100+'%';
  s.style.animationDelay = Math.random()*6+'s';
  s.style.animationDuration = (4+Math.random()*6)+'s';
  stars.appendChild(s);
}

  } catch(e) { console.error(e); }
})();
})();
